import { PageWrapper } from "@/components";
import * as GlobalS from "@/components/styled";
import { GUTTER_SIZE } from "@/enums";
import { compareStrings } from "@/helpers/tableSorter";
import {
  useDeleteNotificationGroupMutation,
  useGetAllNotificationGroupsQuery,
} from "@/services";
import {
  faCirclePlus,
  faEdit,
  faTrash,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Popconfirm, Row, Space, Table } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { EditNotificationGroupModal } from "./components";

const NotificationGroups = () => {
  const intl = useIntl();

  const [selectedNotificationGroup, setSelectedNotificationGroup] = useState();
  const [open, setOpen] = useState(false);

  const {
    data: notificationGroups,
    isFetching,
    refetch: refetchNotificationGroups,
  } = useGetAllNotificationGroupsQuery();

  const [deleteNotificationGroup] = useDeleteNotificationGroupMutation();

  const columns = [
    {
      title: intl.formatMessage({ id: "notificationGroups.colName" }),
      dataIndex: "name",
      sorter: (a, b) => compareStrings(a.name, b.name),
    },
    {
      title: intl.formatMessage({ id: "notificationGroups.colEmail" }),
      dataIndex: "email",
      sorter: (a, b) => compareStrings(a.email, b.email),
    },
    {
      render: (row) => (
        <Space>
          <Button
            data-test-id="edit-distribution-group"
            icon={<FontAwesomeIcon icon={faEdit} />}
            type="link"
            onClick={() => handleEditOnClick(row.id)}
          />
          <Popconfirm
            title={intl.formatMessage({
              id: "notificationGroups.actionDelete",
            })}
            okText={intl.formatMessage({ id: "general.delete" })}
            cancelText={intl.formatMessage({ id: "general.cancel" })}
            onConfirm={() => handleDelete(row.id)}
          >
            <Button
              data-test-id="delete-distribution-group"
              icon={<FontAwesomeIcon icon={faTrash} />}
              type="link"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleDelete = (id) => {
    deleteNotificationGroup({ id })
      .unwrap()
      .then(() => {
        toast.success(
          intl.formatMessage({
            id: "notificationGroups.toastSuccessfulDelete",
          })
        );
        refetchNotificationGroups();
      })
      .catch(() => {
        toast.error(
          intl.formatMessage({ id: "general.toastSomethingWentWrong" })
        );
      });
  };

  const handleAddOnClick = () => {
    setSelectedNotificationGroup();
    setOpen(true);
  };

  const handleEditOnClick = (id) => {
    const notificationGroup = notificationGroups.find(
      (notificationGroup) => notificationGroup.id === id
    );
    setSelectedNotificationGroup(notificationGroup);
    setOpen(true);
  };

  return (
    <>
      <PageWrapper
        pageTitle={intl.formatMessage({ id: "notificationGroups.pageTitle" })}
      >
        <Row gutter={GUTTER_SIZE.large}>
          <GlobalS.PageContentCard
            title={intl.formatMessage({ id: "notificationGroups.tableTitle" })}
            extra={
              <Button
                data-test-id="project-roles-add"
                type="primary"
                icon={<FontAwesomeIcon icon={faCirclePlus} />}
                onClick={handleAddOnClick}
              >
                {intl.formatMessage({ id: "general.add" })}
              </Button>
            }
          >
            <Table
              data-test-id="notification-groups-table"
              columns={columns}
              dataSource={notificationGroups}
              rowKey={({ id }) => id}
              pagination
              loading={isFetching}
              scroll={{ x: true }}
            />
          </GlobalS.PageContentCard>
        </Row>
      </PageWrapper>
      {open && (
        <EditNotificationGroupModal
          open={open}
          setOpen={setOpen}
          selectedNotificationGroup={selectedNotificationGroup}
        />
      )}
    </>
  );
};

export default NotificationGroups;
